import { type AppNode } from '../../types';
import { DEFAULT_CANVAS_IMAGE_HEIGHT, DEFAULT_CANVAS_IMAGE_WIDTH } from './canvasAssetDropConstants';
import { type CanvasAssetPayload, type ImageNodesLayout } from './canvasAssetDropTypes';

/**
 * Builds AppNode[] for video nodes from canvas asset payloads and layout.
 * Mirrors buildImageNodes but creates video-typed nodes for GIF conversion on canvas.
 */
export function buildVideoNodes(
  assets: CanvasAssetPayload[],
  layout: ImageNodesLayout,
  offsetX = 0,
): { nodes: AppNode[]; nextOffsetX: number } {
  const nodes: AppNode[] = [];
  let currentOffsetX = offsetX;

  for (const asset of assets) {
    if (!asset.media?.original) {
      continue;
    }

    const width = asset.width ?? DEFAULT_CANVAS_IMAGE_WIDTH;
    const height = asset.height ?? DEFAULT_CANVAS_IMAGE_HEIGHT;
    const position =
      layout.kind === 'row'
        ? { x: layout.startX + currentOffsetX, y: layout.startY }
        : {
            x: layout.centerX - width / 2 + currentOffsetX,
            y: layout.centerY - height / 2,
          };

    currentOffsetX += width + layout.spacing;

    nodes.push({
      data: {
        assetId: asset.assetId,
        duration: asset.duration,
        fileName: asset.title || asset.importedName || 'Video',
        media: { original: asset.media.original, video: asset.media.original },
        source: 'workspace',
        thumbnailUrl: asset.media.image,
        type: 'video',
        versionId: asset.id,
      },
      id: crypto.randomUUID(),
      position,
      style: { height, width },
      type: 'video',
    });
  }

  return { nextOffsetX: currentOffsetX, nodes };
}
